import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonText,
} from "@ionic/react";

interface Props {
  label: string;
  step: number;
  nbStep: number;
  children: any;
}

const Question: React.FC<Props> = ({ label, step, nbStep, children }) => {
  return (
    <IonCard>
      <IonCardHeader>
        <IonCardSubtitle>
          {step + 1}/{nbStep + 1}
        </IonCardSubtitle>
        <IonText color="dark">
          <h3
            style={{
              textAlign: "center",
            }}
          >
            {label}
          </h3>
        </IonText>
      </IonCardHeader>
      <IonCardContent>{children}</IonCardContent>
    </IonCard>
  );
};

export default Question;
